/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 03.06.25
 *
 */
export const FundingSourceEnum = Object.freeze({
	ASF: "ASF",
	LOCAL: "LOCAL",
	OTHER: "OTHER",
})

export const FundingSourceNameMap = Object.freeze({
	[FundingSourceEnum.ASF]: "ASF",
	[FundingSourceEnum.LOCAL]: "Local",
	[FundingSourceEnum.OTHER]: "Other",
})
